import { IActiveNewbuildingPolygon } from '../../types/map/newbuildingPolygon';
import { IApplicationState } from '../../types/redux';

export function selectActiveNewbuildingPolygon(state: IApplicationState): IActiveNewbuildingPolygon {
  return state.activeNewbuildingPolygon;
}
